import type { CompleteDateRange } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";

export const cloneDateRange = (dateRange: CompleteDateRange): CompleteDateRange => ({
  from: new Date(dateRange.from),
  to: new Date(dateRange.to),
});

export const formatDateRangeKey = (dateRange: CompleteDateRange): string =>
  `${dateRange.from.getTime()}:${dateRange.to.getTime()}`;
